import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { fullScreenAtom } from "../atoms";

const useFullScreenDetect = () => {
  const setFullScreen = useSetAtom(fullScreenAtom);
  useEffect(() => {
    if (document.addEventListener) {
      document.addEventListener("fullscreenchange", exitHandler, false);
      document.addEventListener("mozfullscreenchange", exitHandler, false);
      document.addEventListener("MSFullscreenChange", exitHandler, false);
      document.addEventListener("webkitfullscreenchange", exitHandler, false);
    }

    function exitHandler() {
      if (
        // @ts-ignore
        !document.webkitIsFullScreen &&
        // @ts-ignore
        !document.mozFullScreen &&
        // @ts-ignore
        !document.msFullscreenElement
      ) {
        setFullScreen(false);
      }
    }
  }, []);
};

export default useFullScreenDetect;
